<template>
  <div>
    <b-card :title="locals('inquiry.inquiry_search')">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(0, 207, 232, 0.15)'"
              class="custom-add"
              :to="{ name: 'template-form' }"
              pill
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("button.new") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="12" class="mb-2">
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.company_name')"
                label-for="i-company"
              >
                <v-select
                  id="i-company"
                  v-model="dataFilter.strCustomerName"
                  :placeholder="locals('select.placeholder')"
                  label="title"
                  :options="cust"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.estimate_delivery_date')"
                label-for="i-date"
              >
                <flat-pickr class="form-control" :config="{ mode: 'range' }" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.service')"
                label-for="i-service"
              >
                <v-select
                  input-id="i-service"
                  :clearable="true"
                  v-model="dataFilter.strInqServiceDesc"
                  :placeholder="locals('select.placeholder')"
                  label="title"
                  :options="inquiry_service"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-job-no"
                :label="locals('inquiry.inquiry_job_no')"
              >
                <b-form-input id="i-job-no" v-model="dataFilter.strInqJobNo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                label-for="i-origin"
                :label="locals('inquiry.origin_port')"
              >
                <b-form-input id="i-origin" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-dest"
                :label="locals('inquiry.destination_port')"
              >
                <b-form-input id="i-dest" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-freight-service"
                :label="locals('inquiry.freight_service')"
              >
                <v-select
                  v-model="dataFilter.FreightService"
                  :options="freight_service"
                  label="title"
                >
                  <template #option="{ title, icon }">
                    <font-awesome-icon :icon="icon" />
                    <span> {{ title }}</span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.status')"
                label-for="i-status"
              >
                <v-select
                  id="i-status"
                  :clearable="true"
                  v-model="dataFilter.strStatus"
                  :placeholder="locals('select.placeholder')"
                  input-id="i-status"
                  label="title"
                  :options="status"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1 custom-search"
            pill
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            pill
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card :title="locals('inquiry.inquiry_detail')">
      <b-row class="pt-2">
        <b-col md="12">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
            styleClass="vgt-table condensed"
          >
            <!-- Slot: Table Column -->
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label === 'Action'" class="text-nowrap">
                {{ $t("inquiry.action") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานะ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.status") }}
              </span>
              <span
                v-else-if="props.column.label === 'Inquiry Job no.'"
                class="text-nowrap"
              >
                {{ $t("inquiry.inquiry_job_no") }}
              </span>
              <span
                v-else-if="props.column.label === 'ชื่อบริษัท'"
                class="text-nowrap"
              >
                {{ $t("inquiry.company_name") }}
              </span>
              <span
                v-else-if="props.column.label === 'ด่วน'"
                class="text-nowrap"
              >
                {{ $t("inquiry.urgent") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_date") }}
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <!-- Column: Action -->
              <span v-if="props.column.field === 'action'">
                <div class="text-center">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-warning"
                    class="btn-icon rounded-circle mr-1"
                  >
                     <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                  >
                    <font-awesome-icon icon="fa-solid fa-trash" />
                  </b-button>
                </div>
              </span>
              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'status'">
                <div class="text-center">
                  <b-badge :variant="statusVariant(props.row.status)">
                    {{ props.row.status }}
                  </b-badge>
                </div>
              </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['5', '10', '25']"
                    class="mx-1"
                    @input="
                      (pageLength) =>
                        props.perPageChanged({
                          currentPerPage: pageLength,
                        })
                    "
                  />
                  <span class="text-nowrap">
                    of {{ props.total }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="
                      (pageLength) =>
                        props.pageChanged({
                          currentPage: pageLength,
                        })
                    "
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
} from "bootstrap-vue";

//import js from "@/views/Inquiry/Stores";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Draft: "light-info",
        DRAFT: "light-info",
        Save: "light-success",
        SAVE: "light-success",
        Rejected: "light-danger",
      };

      return (table_status) => statusColor[table_status];
    },
  },
  data() {
    return {
      dataFilter: {
        intCustomerId: 1,
        strCustomerName: "Customer A",
        intInqServiceId: 1,
        strInqServiceDesc: "",
        strInqJobNo: "INQ",
        FreightService: {
          intFreightServiceId: 1,
          title: "",
          icon: "",
        },
        strStatus: "",
      },
      cust: [
        { title: "Customer A" },
        { title: "Customer B" },
        { title: "Customer C" },
        { title: "Customer D" },
      ],
      inquiry_service: [
        { title: "Freight & Shipping", Id: 1 },
        { title: "Legal", Id: 2 },
        { title: "WH & TR", Id: 3 },
        { title: "Bidding", Id: 4 },
      ],
      freight_service: [
        { title: "Sea", Id: 2, icon: "fa-solid fa-ferry" },
        { title: "Air", Id: 1, icon: "fa-solid fa-plane" },
        { title: "Cross Border", Id: 3, icon: "fa-sharp fa-solid fa-truck" },
      ],
      status: [{ title: "ร่าง" }, { title: "บันทึก" }],
      table_status: [
        {
          0: "Draft",
          1: "DRAFT",
          2: "Save",
          3: "SAVE",
          4: "Rejected",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-success",
          3: "light-success",
          4: "light-danger",
        },
      ],
      pageLength: 5,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "150px",
        },
        {
          label: "สถานะ",
          field: "status",
          width: "150px",
        },
        {
          label: "Inquiry Job no.",
          field: "jobNo",
          width: "200px",
        },
        {
          label: "ชื่อบริษัท",
          field: "company",
          width: "200px",
        },
        {
          label: "ด่วน",
          field: "urgent",
          width: "100px",
        },
        {
          label: "ผู้สร้าง",
          field: "createdBy",
          width: "150px",
        },
        {
          label: "วันที่สร้าง",
          field: "createdDate",
          width: "150px",
        },
        {
          label: "ผู้แก้ไข",
          field: "updatedBy",
          width: "150px",
        },
        {
          label: "วันที่แก้ไข",
          field: "updatedDate",
          width: "150px",
        },
      ],
      rows: [
        {
          action: "",
          status: "DRAFT",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer A",
          urgent: "",
        },
        {
          action: "",
          status: "SAVE",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer B",
          urgent: "",
        },
        {
          action: "",
          status: "DRAFT",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer A",
          urgent: "",
        },
        {
          action: "",
          status: "SAVE",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer B",
          urgent: "",
        },
        {
          action: "",
          status: "DRAFT",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer A",
          urgent: "",
        },
        {
          action: "",
          status: "SAVE",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer B",
          urgent: "",
        },
        {
          action: "",
          status: "DRAFT",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer A",
          urgent: "",
        },
        {
          action: "",
          status: "SAVE",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer B",
          urgent: "",
        },
        {
          action: "",
          status: "DRAFT",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer A",
          urgent: "",
        },
        {
          action: "",
          status: "SAVE",
          jobNo: "INQYYYYMMDDXXXX",
          company: "Customer B",
          urgent: "",
        },
      ],
    };
  },
  methods: {
    onAdd() {},
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
